import { create } from 'zustand';
import { getActions } from './actions.js';
export const useCapsuleStore = create(set => (Object.assign({ capsule: undefined }, getActions(set))));
